/**
 * 数字を整数に変換（小数点以下第一位までを想定）
 * @param {Number} number 変換したい数字
 * @param {Boolean} point 取り出したい位が小数点の時 true
 */
export default function toInteger(number, point) {
  if (!point) {
    return Math.floor(number);
  } else {
    number = number * 10;
    number = number.toString();
    number = number.slice(-1);
    number = Number(number);
    return number;
  }
}
